import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import BacktestService from "../../../service/backtest.service";
import ContainerDimensions from "react-container-dimensions";
import AccumulationHelper from "./accumulation.helper";
import DecumulationHelper from "./RIGEquation.helper";
import IRA from "./ira.json";
// import AtRetirement from "./atRetirement";
import StackedBar from "../../d3Components/StackedBarChart/single_stackedBar";
import GroupStackedBar from "../../d3Components/StackedBarChart/group_stackedBar";
import GroupBarWithLine from "../../d3Components/groupBarWithLineChart/groupBarWithLine";

import MultiAreaChart from "../../d3Components/multiAreaChart/multiAreaChart";
import FIEQDATA from "./FIEQ.json";

import CommonButton from "../../common/commonButton";
// import Cards from "../../myPortfolios/cards/cards";
// import Spinner from "../../PortfolioDashboard/navigationPages/Datatable/spinner/spinner";
import moneyFormatter from "../../common/moneyFormatter.js";

import "./accumulation.scss";

const { Slider } = window;
class Accumulation extends Component {
  ranges = [];
  incomeSourceRanges = [];
  state = {
    analyze: false,
    current_Age: [],
    retirement_Age: [],
    showCalculator: false,
    stackedChartData: [],
    liveData: [],
    selectedFundValue: 2.2,
    selectedRadioButton: 999,
    selectedFundName: " TYPICAL CAPITAL PROTECTION FUND",
    groupStackedBarChartData: [],
    groupBarWithLineData: [],
    groupBarWithLineLabels: [],
    IRA20YRS: 0,
    IRA2: 0
  };

  // toggle fields
  AnalyzeButtonHandler = () => {
    const { acc_analizeButtonClicked, analyzeHandler } = this.props;
    analyzeHandler(acc_analizeButtonClicked + 1);
    this.setState({
      analyze: true
    });
  };

  FieldTwoHandler = () => {
    this.setState({
      analyze: !this.state.analyze
    });
  };

  calculatorHandler = e => {
    e.preventDefault();
    let value = (e.target.value * 70) / 100;
    this.props.setSavings_Sliders("annualIncomeNeeded", value);
  };

  inputFieldHandler = e => {
    this.props.setSavings_Sliders(e.target.name, e.target.value);
  };

  async componentWillMount() {
    let current_Age = AccumulationHelper.dropDown_AGE(20, 60);
    let retirement_Age = AccumulationHelper.dropDown_AGE(60, 75);

    this.setState({
      current_Age,
      retirement_Age
    });
    await BacktestService.getScenariosNew("LIVE").then(res => {
      let live = [
        {
          benchmark_name: "Benchmark: Capital Protection Benchmark",
          bm_annualized_return: 0.022,
          fund_annualized_return: 0.022,
          scenario_id: 999,
          type: "LIVE"
        }
      ];

      for (var i in res) {
        var obj = {};
        obj["scenario_id"] = res[i]["scenario_id"];
        obj["type"] = res[i]["type"];
        obj["bm_annualized_return"] = res[i]["bm_annualized_return"];
        obj["fund_annualized_return"] = res[i]["fund_annualized_return"];
        obj["scenario_name"] = res[i]["scenario_name"];
        obj["alpha"] = res[i]["alpha"];
        obj["beta"] = res[i]["beta"];
        obj["sortino_ratio"] = res[i]["sortino_ratio"];
        obj["benchmark_name"] = res[i]["benchmark_name"];
        obj["benchmark"] = res[i]["benchmark"];
        obj["scn_status"] = res[i]["scn_status"].toUpperCase();
        live.push(obj);
      }

      let filteredData = live.filter(
        e =>
          e.scenario_id == 706 || e.scenario_id == 707 || e.scenario_id == 999
      );
      let list = [];
      filteredData.map(el => list.push(el.fund_annualized_return));

      console.log(
        filteredData,
        list,
        "--------accumulation live data------------"
      );

      this.props.setFundList(list);
      if (list.length > 0) {
        let groupBarWithLineLabels = [
          `Moderate (${(list[2] * 100).toFixed(2)}%)`,
          `Conservative (${(list[1] * 100).toFixed(2)}%)`,
          `Capital Protection (${(list[0] * 100).toFixed(2)}%)`
        ];

        this.setState({
          liveData: filteredData,
          groupBarWithLineLabels
        });
      }
    });
    this.estimatedSavings(this.props);
  }

  componentDidMount() {
    setTimeout(() => this.renderRange(), 0);
    if (!this.props.activeGlidePath) {
      setTimeout(() => this.IncomeSourceSlider(), 0);
    }
    this.updateInvestmentSource(this.props);
    // stacked chart
    this.stackedChart(this.props);

    // setting stacked group barchart data;
    if (this.props.fundList.length > 0) {
      this.groupStackedBarChart(this.props);
    }
  }
  componentWillReceiveProps(nextProps) {
    const {
      currentAge,
      retirementAge,
      currentSavings,
      possibleAnnualSavings,
      acc_selectedPortfolio,
      fundList
    } = nextProps;

    this.groupStackedBarChart(nextProps);
    if (
      currentAge !== this.props.currentAge ||
      retirementAge !== this.props.retirementAge ||
      currentSavings !== this.props.currentSavings ||
      possibleAnnualSavings !== this.props.possibleAnnualSavings ||
      acc_selectedPortfolio !== this.props.acc_selectedPortfolio
    ) {
      this.estimatedSavings(nextProps);

      this.updateInvestmentSource(nextProps);
    }

    // setting stacked group barchart data;
    setTimeout(() => this.renderRange(), 0);
    if (!nextProps.activeGlidePath) {
      setTimeout(() => this.IncomeSourceSlider(), 0);
    }
    // stacked chart
    setTimeout(() => this.stackedChart(nextProps), 0);
  }
  // render ranges
  renderRange = () => {
    const {
      currentSavings,
      possibleAnnualSavings,
      annualIncomeNeeded,
      possibleAnnualIRA
    } = this.props;

    const currentSaving_option = {
      // formatter: value => `${value}$`,
      formatter: value => ``,
      tooltip: "always",
      tooltip_position: "bottom",
      step: 1000,
      min: 0,
      max: 1000000,
      id: id => id
    };
    const possibleSaving_option = {
      formatter: value => ``,
      tooltip: "always",
      tooltip_position: "bottom",
      step: 1000,
      min: 0,
      max: 1000000,
      id: id => id
    };
    const incomeNeeded_option = {
      formatter: value => ``,
      tooltip: "always",
      tooltip_position: "bottom",
      step: 1000,
      min: 0,
      max: 1000000,
      id: id => id
    };
    // clearing previous slider dom
    if (this.ranges.length) {
      this.ranges.forEach(fn => {
        fn.destroy();
      });
      this.ranges = [];
    }
    var current = new Slider(`#current_savings`, {
      ...currentSaving_option,
      value: +currentSavings,
      id: "currentSavings"
    });
    var possible = new Slider(`#possible_savings`, {
      ...possibleSaving_option,
      value: +possibleAnnualSavings,
      id: "possibleAnnualSavings"
    });
    var ira = new Slider(`#possible_IRA`, {
      ...possibleSaving_option,
      value: +possibleAnnualIRA,
      id: "possibleAnnualIRA"
    });
    var income = new Slider(`#income_needed`, {
      ...incomeNeeded_option,
      value: +annualIncomeNeeded,
      id: "annualIncomeNeeded"
    });
    this.ranges.push(current, possible, ira, income);
  };
  onSliderChange = id => {
    const range = this.ranges;
    const filteredRange = range.filter(d => d.options.id == id);
    if (filteredRange[0]["options"]["id"] == id) {
      let value = filteredRange[0]["_state"]["value"][0];

      this.props.setSavings_Sliders(id, value);
    }
  };

  // set estimated savings

  estimatedSavings = props => {
    const {
      setEstimatedSavings,
      currentSavings,
      possibleAnnualSavings,
      acc_selectedPortfolio,
      retirementAge,
      currentAge,
      fundList
    } = props;
    const { groupBarWithLineData } = this.state;

    let estimatedSavings = AccumulationHelper.estimatedSavings(
      currentSavings,
      possibleAnnualSavings,
      acc_selectedPortfolio,
      retirementAge * 1 - currentAge * 1
    );
    if (!props.activeGlidePath) {
      setEstimatedSavings(estimatedSavings * 1);
    } else {
      // group bar with line data
      let end_year = retirementAge - currentAge;

      let investMentGlidePath = AccumulationHelper.glidePathDataCalc(
        end_year,
        currentSavings,
        possibleAnnualSavings,
        fundList[0],
        fundList[1],
        fundList[2]
      );

      let lastGlideValue =
        investMentGlidePath[investMentGlidePath.length - 1]["investment"];
      setEstimatedSavings(lastGlideValue * 1);
    }
  };
  // income source sliders
  IncomeSourceSlider = () => {
    const { socialSecurity, acc_otherIncome } = this.props;
    const op1 = {
      // formatter: value => `${value}$`,
      formatter: value => ``,
      tooltip: "always",
      tooltip_position: "bottom",
      step: 1000,
      min: 0,
      max: 1000000,
      id: id => id
    };
    const op2 = {
      // formatter: value => `${value}$`,
      formatter: value => ``,
      tooltip: "always",
      tooltip_position: "bottom",
      step: 1000,
      min: 0,
      max: 1000000,
      id: id => id
    };
    // clear prev slider
    if (this.incomeSourceRanges.length) {
      this.incomeSourceRanges.forEach(fn => {
        fn.destroy();
      });
      this.incomeSourceRanges = [];
    }

    var social = new Slider(`#socialSecurity`, {
      ...op1,
      value: +socialSecurity,
      id: "socialSecurity"
    });
    var possible = new Slider(`#acc_otherIncome`, {
      ...op2,
      value: +acc_otherIncome,
      id: "acc_otherIncome"
    });
    this.incomeSourceRanges.push(social, possible);
  };
  sourceSliderHandler = id => {
    const incomeSourceRanges = this.incomeSourceRanges;
    const filteredRange = incomeSourceRanges.filter(d => d.options.id == id);
    if (filteredRange[0]["options"]["id"] == id) {
      let value = filteredRange[0]["_state"]["value"][0];

      this.props.setSOURCE(id, value);
    }
  };

  // radio button handler
  setFundType = e => {
    let value = e.currentTarget.value * 1;
    const { groupBarWithLineData } = this.state;
    const { setGlidePath, activeGlidePath, setEstimatedSavings } = this.props;

    // this.stackedChart(this.props);

    if (value == 0) {
      setGlidePath(!activeGlidePath);

      let lastGlideValue =
        groupBarWithLineData[groupBarWithLineData.length - 1]["investment"];
      this.props.setSelectedPortfolio(2.2);

      setEstimatedSavings(lastGlideValue);
    } else {
      this.props.setSelectedPortfolio(value.toFixed(2) * 1);
      this.props.setSelectedId(e.target.id * 1);

      this.setState(
        {
          selectedFundValue: value * 1,
          selectedRadioButton: e.target.id,
          selectedFundName: e.target.name
        },
        () => this.estimatedSavings(this.props),
        () => this.updateInvestmentSource(this.props)
      );

      setGlidePath(false);
    }
  };

  // income source handler
  sourceHandler = e => {
    this.updateInvestmentSource(this.props);

    this.props.setSOURCE(e.target.name, e.target.value);
  };

  // investment source update
  updateInvestmentSource = ({
    currentSavings,
    possibleAnnualSavings,
    retirementAge,
    currentAge,
    estimatedSavings
  }) => {
    const { acc_selectedPortfolio } = this.props;

    var investmentSoure = (
      estimatedSavings *
      (acc_selectedPortfolio / 100)
    ).toFixed();
    this.props.setSOURCE("investmentSource", investmentSoure * 1);
  };
  // stacked chart data
  stackedChart = props => {
    // ********** toggle break down & stacked chart data ***********
    const {
      possibleAnnualIRA,
      dec_investmentSource,
      age,
      rate,
      socialSecurity,
      investmentSource,
      acc_otherIncome,
      annualIncomeNeeded,
      acc_selectedPortfolio
    } = props;
    console.log(props, "--------props from Accumulation stacked------------");
    let estimatedSavings =
      AccumulationHelper.estimatedSavings(
        props.currentSavings,
        props.possibleAnnualSavings,
        props.acc_selectedPortfolio,
        props.retirementAge * 1 - props.currentAge * 1
      ) * 1;

    var savings = estimatedSavings;
    var withdraw = annualIncomeNeeded;
    var dec_socialSecurity = props.socialSecurity;
    var dec_otherIncome = props.acc_otherIncome;
    var retirementAccount = props.possibleAnnualIRA * (props.retirementAge * 1 - props.currentAge * 1);


    var Data = DecumulationHelper.Data({
      savings,
      withdraw,
      dec_socialSecurity,
      dec_otherIncome,
      dec_investmentSource,
      retirementAccount,
      age,
      rate
    });

    console.log(Data, "-----------Data from Accumulation----------------");

    const calc_SavingsMeetszero = () => {
      let arr = [];
      for (let i = 1; i < Data[0].length; i++) {
        let x = Data[0][i];
        if (x["Withdraw from Savings"] === 0) {
          arr.push(i);
        }
      }
      return arr.length === 0 ? 20 : arr[0];
    };

    // let IRA_NextStep =
    //   (possibleAnnualIRA *
    //     (this.props.retirementAge * 1 - this.props.currentAge * 1)) /
    //   IRA["70"];

    let IRA_NextStep =  Data[0][Data[0].length - 1]["IRA"];
    
    var IRA20YRS = AccumulationHelper.calc_targetBreakDown(
      estimatedSavings,
      acc_selectedPortfolio / 100,
      socialSecurity,
      IRA_NextStep
    );

    let new_arr = [];
    let obj = {};
    let title = [];

    let investment_source = +(
      estimatedSavings *
      (acc_selectedPortfolio / 100)
    ).toFixed(2);

    let withDraw_from_savings;
    let withDrawFromSavigs =
      annualIncomeNeeded -
      (socialSecurity + acc_otherIncome + investment_source + IRA_NextStep);
    if (withDrawFromSavigs <= 0) {
      withDraw_from_savings = 0;
    } else {
      withDraw_from_savings = +withDrawFromSavigs.toFixed(2);
    }
    if (possibleAnnualIRA > 0) {
      obj["socialSecurity"] = Data[0][Data[0].length - 1]["Social Security"];
      obj["possibeIRA"] = Data[0][Data[0].length - 1]["IRA"];
      obj["acc_otherIncome"] = Data[0][Data[0].length - 1]["Other Income"];
      obj["investmentSource"] =
        Data[0][Data[0].length - 1]["Investment Source"];
      obj["withdrawFromSavings"] =
        Data[0][Data[0].length - 1]["Withdraw from Savings"];
    } else {
      obj["socialSecurity"] = socialSecurity * 1;
      obj["possibeIRA"] = IRA_NextStep;
      obj["acc_otherIncome"] = acc_otherIncome * 1;
      obj["investmentSource"] = investment_source;
      obj["withdrawFromSavings"] = withDraw_from_savings;
    }
    // +(estimatedSavings / 20).toFixed(2)

    title = [
      "SOCIAL SECURITY",
      "Possibe IRA",
      "OTHER INCOME",
      "INVESTMENT SOURCE",
      "Withdraw From Savings"
    ];
    obj["title"] = title;

    new_arr.push(obj);

    this.setState({
      IRA20YRS,
      IRA2: calc_SavingsMeetszero(),
      stackedChartData: new_arr
    });
  };
  // group stacked BarChart data calculation
  groupStackedBarChart = ({
    currentAge,
    retirementAge,
    currentSavings,
    possibleAnnualSavings,
    acc_selectedPortfolio,
    fundList
  }) => {
    let data = [];
    let year = new Date().getFullYear();
    let end_year = retirementAge - currentAge;

    for (let i = 0; i <= end_year; i++) {
      var obj = {};
      var cal =
        AccumulationHelper.estimatedSavings(
          currentSavings,
          possibleAnnualSavings,
          acc_selectedPortfolio,
          i
        ) *
          1 -
        AccumulationHelper.estimatedSavings(
          currentSavings,
          possibleAnnualSavings,
          acc_selectedPortfolio,
          i - 1
        ) *
          1 -
        possibleAnnualSavings;

      var interest_gained = i !== 0 ? +cal.toFixed(2) : 0;

      var invest = (
        AccumulationHelper.estimatedSavings(
          currentSavings,
          possibleAnnualSavings,
          acc_selectedPortfolio,
          i
        ) *
          1 -
        interest_gained
      ).toFixed(2);

      obj["year"] = (year * 1 + i).toString();
      obj["investment"] = invest;

      obj["returns"] = interest_gained;

      data.push(obj);
    }

    // group bar with line data
    let investMentGlidePath = AccumulationHelper.glidePathDataCalc(
      end_year,
      currentSavings,
      possibleAnnualSavings,
      fundList[0],
      fundList[1],
      fundList[2]
    );

    console.log(investMentGlidePath, "new line data");
    this.setState({
      groupStackedBarChartData: data,
      groupBarWithLineData: investMentGlidePath
    });
  };

  // navigate to decumulation and set values of accumulation to decumulation
  navigateToDecumulation = () => {
    const {
      setDecumulationValues,
      navToNextPage,
      estimatedSavings
    } = this.props;

    setDecumulationValues("dec_socialSecurity", this.props.socialSecurity);
    setDecumulationValues("dec_otherIncome", this.props.acc_otherIncome);
    setDecumulationValues("withdraw", this.props.annualIncomeNeeded);
    setDecumulationValues("age", this.props.retirementAge);
    setDecumulationValues("savings", estimatedSavings);
    setDecumulationValues(
      "retirementAccount",
      this.props.possibleAnnualIRA *
        (this.props.retirementAge - this.props.currentAge)
    );

    navToNextPage();
  };

  handleOutsideClick = e => {
    // ignore clicks on the component itself
    if (e && e.target !== null && this.node.contains(e.target)) {
      return;
    }
    this.toggleCalculator();
  };

  // removing pop up click else where
  toggleCalculator = () => {
    if (!this.state.showCalculator) {
      // attach/remove event handler
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState((state, prop) => ({
      showCalculator: !state.showCalculator
    }));
  };
  componentWillUnmount() {
    if (this.state.showCalculator) {
      this.handleOutsideClick();
    }
  }

  render() {
    const {
      current_Age,
      retirement_Age,
      showCalculator,
      liveData,
      stackedChartData,
      groupStackedBarChartData,
      analyze,
      IRA20YRS,
      IRA2,
      groupBarWithLineData,
      groupBarWithLineLabels
    } = this.state;
    const {
      setAGE,
      currentAge,
      retirementAge,
      currentSavings,
      possibleAnnualSavings,
      possibleAnnualIRA,
      annualIncomeNeeded,
      socialSecurity,
      acc_otherIncome,
      acc_selectedPortfolio,
      acc_analizeButtonClicked,
      acc_id,
      activeGlidePath,
      estimatedSavings
    } = this.props;

    return (
      <div className="page-body">
        <div className="step clearfix">
          <Fragment>
            {acc_analizeButtonClicked === 0 ? (
              <div className="accumulation_header">
                <div>
                  <b>ABOUT CLIENT :</b>
                </div>
              </div>
            ) : (
              <div
                className="accumulation_header"
                onClick={this.FieldTwoHandler}
                style={{ cursor: "pointer" }}
              >
                <div className="accumulation_header_content">
                  <div>Age - {currentAge} YRS</div>
                  <div>Retire at {retirementAge} YRS</div>
                  <div>Savings - {moneyFormatter(currentSavings)}</div>
                  <div>
                    Annual Savings - {moneyFormatter(possibleAnnualSavings)}
                  </div>
                  <div>
                    Annual IRA Contribution- {moneyFormatter(possibleAnnualIRA)}
                  </div>
                  <div>
                    Retirement Income Needed -{" "}
                    {moneyFormatter(annualIncomeNeeded)}
                  </div>
                </div>
                <i
                  className={`fa fa-2x bounce ${
                    !this.state.analyze
                      ? `fa-angle-double-up`
                      : `fa-angle-double-down`
                  } `}
                ></i>
              </div>
            )}
          </Fragment>
          <Fragment>
            <div
              style={{
                display: analyze === false ? "block" : "none"
              }}
              className="accumulation_container"
            >
              <div id="collapseExample" style={{ padding: "0px 15px" }}>
                <div className="row">
                  <div className="col-md-3 my-auto">
                    <div className="accumulation_card">
                      <h4 style={{ fontWeight: "bold" }}>
                        CURRENT AGE OF CLIENT
                      </h4>
                      <div className="custom-select" style={{ width: "80%" }}>
                        <select
                          className="form-control"
                          onChange={e => setAGE("currentAge", e.target.value)}
                          defaultValue={currentAge}
                        >
                          {current_Age.map((e, i) => (
                            <option value={e} key={i}>
                              {e}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 my-auto">
                    <div className="accumulation_card">
                      <h4 style={{ fontWeight: "bold" }}>RETIREMENT AGE</h4>
                      <div className="custom-select" style={{ width: "80%" }}>
                        <select
                          className="form-control"
                          onChange={e =>
                            setAGE("retirementAge", e.target.value)
                          }
                          defaultValue={retirementAge}
                        >
                          {retirement_Age.map((age, i) => (
                            <option value={age} key={i}>
                              {age}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 my-auto">
                    <div className="accumulation_card">
                      <h4 style={{ fontWeight: "bold" }}>CURRENT SAVINGS</h4>
                      <input
                        type="number"
                        placeholder="$100000"
                        min="0"
                        value={currentSavings}
                        className="acc_input"
                        name="currentSavings"
                        onChange={this.inputFieldHandler}
                      />
                      <div
                        onClick={() => this.onSliderChange("currentSavings")}
                      >
                        <div id={`current_savings`} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 my-auto">
                    <div className="accumulation_card">
                      <h4 style={{ fontWeight: "bold" }}>
                        POSSIBLE ANNUAL SAVINGS
                      </h4>
                      <input
                        type="number"
                        placeholder="$20000"
                        min="0"
                        className="acc_input"
                        value={possibleAnnualSavings}
                        name="possibleAnnualSavings"
                        onChange={this.inputFieldHandler}
                      />
                      <div
                        onClick={() =>
                          this.onSliderChange("possibleAnnualSavings")
                        }
                      >
                        <div id={`possible_savings`} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 my-auto">
                    <div className="accumulation_card">
                      <h4 style={{ fontWeight: "bold" }}>
                        ANNUAL IRA CONTRIBUTION
                      </h4>
                      <input
                        type="number"
                        placeholder="$20000"
                        min="0"
                        className="acc_input"
                        value={possibleAnnualIRA}
                        name="possibleAnnualIRA"
                        onChange={this.inputFieldHandler}
                      />
                      <div
                        onClick={() => this.onSliderChange("possibleAnnualIRA")}
                      >
                        <div id={`possible_IRA`} />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 my-auto">
                    <div className="accumulation_card">
                      <h4 style={{ fontWeight: "bold" }}>
                        ANNUAL RETIREMENT INCOME NEEDED
                      </h4>
                      <div>
                        <a onClick={() => this.toggleCalculator()}>
                          USE OUR CALCULATOR
                        </a>
                      </div>

                      <ul
                        className="acc_popUP"
                        id="acc_popUP"
                        role="menu"
                        aria-labelledby="menu1"
                        style={{
                          display: showCalculator == true ? "block" : "none"
                        }}
                        ref={node => {
                          this.node = node;
                        }}
                      >
                        <div className="notch"></div>
                        <Fragment>
                          <li style={{ color: "#fff" }}>
                            <b>What is your current Annual Income ?</b>
                          </li>
                          <li
                            role="presentation"
                            style={{ textAlign: "center", marginTop: "5px" }}
                          >
                            <input
                              type="number"
                              placeholder="$50000"
                              min="10000"
                              max="1000000"
                              style={{ padding: "10px", width: "80%" }}
                              onChange={this.calculatorHandler}
                            />
                          </li>
                        </Fragment>
                      </ul>

                      <input
                        type="number"
                        placeholder="$70000"
                        value={annualIncomeNeeded}
                        min="0"
                        className="acc_input"
                        name="annualIncomeNeeded"
                        onChange={this.inputFieldHandler}
                      />
                      <div
                        onClick={() =>
                          this.onSliderChange("annualIncomeNeeded")
                        }
                      >
                        <div id={`income_needed`} />
                      </div>
                    </div>
                  </div>
                </div>
                {acc_analizeButtonClicked === 0 ? (
                  <div style={{ display: "flex" }}>
                    <CommonButton
                      onClick={this.AnalyzeButtonHandler}
                      style={{ marginLeft: "auto" }}
                    >
                      Analyze
                    </CommonButton>
                  </div>
                ) : null}
              </div>
            </div>
          </Fragment>
          <div
            style={{
              display: acc_analizeButtonClicked >= 1 ? "block" : "none"
            }}
            className="accumulation_container"
          >
            <div className="radioHolder">
              {liveData.map((d, i) => {
                return (
                  <div key={i}>
                    <input
                      type="radio"
                      name={
                        d.scenario_id == 999
                          ? " TYPICAL CAPITAL PROTECTION FUND"
                          : d.scenario_id == 706
                          ? " IQCIO CONSERVATIVE FUND"
                          : " IQCIO MODERATE FUND"
                      }
                      value={d.fund_annualized_return * 100}
                      id={d.scenario_id * 1}
                      checked={
                        acc_id == d.scenario_id && !activeGlidePath
                          ? "checked"
                          : ""
                      }
                      onChange={this.setFundType}
                      style={{ marginRight: "5px" }}
                    />{" "}
                    {d.scenario_id == 999
                      ? ` TYPICAL CAPITAL PROTECTION FUND (${(
                          +d.fund_annualized_return * 100
                        ).toFixed(2)}%)`
                      : d.scenario_id == 706
                      ? ` IQCIO CONSERVATIVE FUND (${(
                          +d.fund_annualized_return * 100
                        ).toFixed(2)}%)`
                      : ` IQCIO MODERATE FUND (${(
                          +d.fund_annualized_return * 100
                        ).toFixed(2)}%)`}
                  </div>
                );
              })}
              <div style={{ display: "flex", alignItems: "center" }}>
                <input
                  type="radio"
                  name={"glide"}
                  value={0}
                  id={"glide_radio"}
                  checked={activeGlidePath ? "checked" : ""}
                  onChange={this.setFundType}
                  style={{ marginRight: "5px" }}
                />{" "}
                Glide Path Investment
                {/* <ToggleSwitch
                  Name={"toggleButton"}
                  id={"toggle_01"}
                  defaultChecked={false}
                  Small={true}
                  onChange={() =>
                    this.setState({
                      showGlidePath: !showGlidePath
                    })
                  }
                /> */}
              </div>
            </div>
            <div style={{ display: activeGlidePath ? "none" : "block" }}>
              <div className="acc_headHolder">
                <div className="yoy">YoY ACCUMULATION</div>
                <div className="target_break">TARGET BREAKDOWN</div>
              </div>
            </div>
            <div id="collapseExample2">
              <div
                className="row"
                style={{ display: activeGlidePath ? "none" : "block" }}
              >
                <div className="col-md-6">
                  <div style={{ fontSize: "16px" }}>
                    Estimated Savings at retirement :{" "}
                    <b>{moneyFormatter(estimatedSavings)}</b>
                  </div>
                  {acc_selectedPortfolio === 2.2 ? (
                    <div>(Without Investment Plan)</div>
                  ) : null}
                  {groupStackedBarChartData.length > 0 ? (
                    <ContainerDimensions>
                      {({ width }) => (
                        <Fragment>
                          {width > 0 ? (
                            <GroupStackedBar
                              id="group-stacked-bar"
                              width={width}
                              height="400"
                              data={groupStackedBarChartData}
                            />
                          ) : null}
                        </Fragment>
                      )}
                    </ContainerDimensions>
                  ) : null}
                </div>
                <div className="col-md-6">
                  {IRA20YRS > this.props.annualIncomeNeeded ? (
                    <div style={{ textAlign: "center" }}>
                      <span style={{ fontSize: "16px", padding: "10px 0px" }}>
                        <b>
                          {(this.props.annualIncomeNeeded / 1000).toFixed()}
                          K/YR for {IRA2} YRS
                        </b>
                      </span>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        padding: "10px 0px",
                        alignItems: "center"
                      }}
                    >
                      <span style={{ fontSize: "16px" }}>
                        <b>{(IRA20YRS / 1000).toFixed(2)}K/YR for 20 YRS</b>
                      </span>
                      <div
                        style={{
                          height: "50px",
                          backgroundColor: "#999",
                          border: "1px solid #ddd",
                          borderRadius: "50%",
                          color: "#fff",
                          textAlign: "center",
                          padding: "14px"
                        }}
                      >
                        <b>OR</b>
                      </div>
                      <span style={{ fontSize: "16px" }}>
                        <b>
                          {(this.props.annualIncomeNeeded / 1000).toFixed()}
                          K/YR for {IRA2} YRS
                        </b>
                      </span>
                    </div>
                  )}
                  <div style={{ textAlign: "center" }}>
                    {Object.keys(stackedChartData).length > 0 ? (
                      <ContainerDimensions>
                        {({ width }) => (
                          <Fragment>
                            {width > 0 ? (
                              <StackedBar
                                width={width}
                                data={stackedChartData}
                                id="Single-stackedbar"
                              />
                            ) : null}
                          </Fragment>
                        )}
                      </ContainerDimensions>
                    ) : null}
                  </div>
                </div>
              </div>

              <Fragment>
                <div
                  className="col-md-12"
                  style={{ display: activeGlidePath ? "block" : "none" }}
                >
                  <div
                    className="col-md-12"
                    style={{ float: "left", fontSize: "16px" }}
                  >
                    Estimated savings at retirement :{" "}
                    <b>{moneyFormatter(estimatedSavings)}</b>
                  </div>
                  <div className="col-md-8">
                    <h4
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        padding: "10px 0px"
                      }}
                    >
                      INVESTMENT GLIDE PATH
                    </h4>
                    {groupBarWithLineData.length > 0 ? (
                      <ContainerDimensions>
                        {({ width }) => (
                          <Fragment>
                            {width > 0 ? (
                              <GroupBarWithLine
                                id="group_bar_with_line"
                                width={width}
                                data={groupBarWithLineData}
                                labels={groupBarWithLineLabels}
                              />
                            ) : null}
                          </Fragment>
                        )}
                      </ContainerDimensions>
                    ) : null}
                  </div>
                  <div className="col-md-4">
                    <h4
                      style={{
                        fontWeight: "bold",
                        fontSize: "18px",
                        padding: "10px 0px"
                      }}
                    >
                      RISK GLIDE PATH
                    </h4>
                    <ContainerDimensions>
                      {({ width }) => (
                        <Fragment>
                          {width > 0 ? (
                            <MultiAreaChart
                              id="MultiAreaChart"
                              width={width}
                              data={FIEQDATA}
                              vLinePoint={
                                new Date().getFullYear() +
                                (retirementAge - currentAge)
                              }
                            />
                          ) : null}
                        </Fragment>
                      )}
                    </ContainerDimensions>
                  </div>
                </div>
              </Fragment>
              <Fragment>
                {!activeGlidePath ? (
                  <div className="col-md-12 incomeSource-parent">
                    <div className="col-md-2 align-middle">
                      <h4 style={{ fontWeight: "bold" }}>INCOME SOURCE</h4>
                    </div>
                    <div className="col-md-10" style={{ display: "flex" }}>
                      <div className="col-md-4 my-auto">
                        <div className="accumulation_card">
                          <h4 style={{ fontWeight: "bold" }}>
                            {" "}
                            Social Security
                          </h4>
                          <input
                            type="number"
                            placeholder="$20000"
                            min="0"
                            max="1000000"
                            value={socialSecurity}
                            className="acc_input"
                            name="socialSecurity"
                            onChange={this.sourceHandler}
                          />

                          <div
                            onClick={() => {
                              this.sourceSliderHandler("socialSecurity");
                            }}
                          >
                            <div id={`socialSecurity`} />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 my-auto">
                        <div className="accumulation_card">
                          <h4 style={{ fontWeight: "bold" }}>Other Income</h4>
                          <input
                            type="number"
                            placeholder="$10000"
                            min="0"
                            max="1000000"
                            value={acc_otherIncome}
                            className="acc_input"
                            name="acc_otherIncome"
                            onChange={this.sourceHandler}
                          />
                          <div
                            onClick={() => {
                              this.sourceSliderHandler("acc_otherIncome");
                            }}
                          >
                            <div id={`acc_otherIncome`} />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 my-auto">
                        <div
                          className="accumulation_card"
                          style={{
                            textAlign: "center"
                          }}
                        >
                          <h4 style={{ fontWeight: "bold" }}>
                            Investment Sources
                          </h4>
                          <h3
                            style={{
                              fontWeight: "bold"
                            }}
                          >
                            {moneyFormatter(
                              estimatedSavings * (acc_selectedPortfolio / 100)
                            )}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
                {/* <table className="fundTypeTable">
                  <thead>
                    <tr>
                      {liveData
                        .filter(
                          e =>
                            e.scenario_id == 706 ||
                            e.scenario_id == 707 ||
                            e.scenario_id == 999
                        )
                        .map((d, i) => {
                          return (
                            <th key={i}>
                              <input
                                type="radio"
                                name={
                                  d.scenario_id == 999
                                    ? " TYPICAL CAPITAL PROTECTION FUND"
                                    : d.scenario_id == 706
                                    ? " IQCIO CONSERVATIVE FUND"
                                    : " IQCIO MODERATE FUND"
                                }
                                value={d.fund_annualized_return * 100}
                                id={d.scenario_id * 1}
                                checked={
                                  acc_id == d.scenario_id ? "checked" : ""
                                }
                                onChange={this.setFundType}
                              />
                              {d.scenario_id == 999
                                ? " TYPICAL CAPITAL PROTECTION FUND"
                                : d.scenario_id == 706
                                ? " IQCIO CONSERVATIVE FUND"
                                : " IQCIO MODERATE FUND"}
                            </th>
                          );
                        })}
                    </tr>
                  </thead>
                  <tbody>
                    {liveData.length ? (
                      <tr>
                        <Fragment>
                          {liveData
                            .filter(
                              e =>
                                e.scenario_id == 706 ||
                                e.scenario_id == 707 ||
                                e.scenario_id == 999
                            )
                            .map((portfolio, i) => {
                              return (
                                <td key={i}>
                                  <Cards
                                    key={i}
                                    data={portfolio}
                                    keyData={i}
                                    link={false}
                                    heading={false}
                                    footer={false}
                                    border={false}
                                  />
                                </td>
                              );
                            })}
                        </Fragment>
                      </tr>
                    ) : (
                      <tr>
                        <td style={{ padding: "10px 0px" }}>
                          <Spinner />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>  */}
              </Fragment>
              {/* <div>
                <AtRetirement
                  selectedFundName={selectedFundName}
                  id={acc_id * 1}
                />
              </div> */}
            </div>
            <div style={{ float: "right", margin: "10px 0px" }}>
              <CommonButton
                onClick={() => this.navigateToDecumulation()}
                style={{ marginLeft: "auto" }}
              >
                VIEW DECUMULATION
              </CommonButton>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  ({
    retirement: {
      rig: {
        accumulation: {
          currentAge,
          retirementAge,
          currentSavings,
          possibleAnnualSavings,
          possibleAnnualIRA,
          annualIncomeNeeded,
          socialSecurity,
          acc_otherIncome,
          investmentSource,
          acc_selectedPortfolio,
          acc_analizeButtonClicked,
          acc_id,
          activeGlidePath,
          estimatedSavings,
          fundList
        },
        equation: {
          savings,
          withdraw,
          dec_socialSecurity,
          dec_otherIncome,
          dec_investmentSource,
          retirementAccount,
          age,
          donut: { rate }
        }
      }
    }
  }) => ({
    currentAge,
    retirementAge,
    currentSavings,
    possibleAnnualSavings,
    possibleAnnualIRA,
    annualIncomeNeeded,
    socialSecurity,
    acc_otherIncome,
    investmentSource,
    acc_analizeButtonClicked,
    savings,
    withdraw,
    dec_socialSecurity,
    dec_otherIncome,
    dec_investmentSource,
    retirementAccount,
    age,
    rate,
    acc_selectedPortfolio,
    acc_id,
    activeGlidePath,
    estimatedSavings,
    fundList
  }),
  dispatch => ({
    setAGE: (name, value) =>
      dispatch({ type: "ACCUMULATION_SET_AGE", payload: { name, value } }),
    setSavings_Sliders: (name, value) =>
      dispatch({
        type: "ACCUMULATION_SET_SAVINGS_NEEDED",
        payload: { name, value }
      }),
    setSOURCE: (name, value) =>
      dispatch({ type: "ACCUMULATION_SET_SOURCE", payload: { name, value } }),
    setDecumulationValues: (name, value) =>
      dispatch({
        type: "DECUMULATION_VALUES_SET_FROM_ACCUMULATION_PAGE",
        payload: { name, value }
      }),
    setSelectedPortfolio: value =>
      dispatch({
        type: "SET_ACCUMULATION_SELECTED_PORTFOLIO",
        payload: { value }
      }),
    setEstimatedSavings: value =>
      dispatch({
        type: "SET_ACCUMULATION_ESTIMATEDSAVINGS",
        payload: { value }
      }),
    setSelectedId: value =>
      dispatch({
        type: "SET_ACCUMULATION_SELECTED_ACCID",
        payload: { value }
      }),
    analyzeHandler: value =>
      dispatch({ type: "ACCUMULATION_ANALYZE_HANDLER", payload: { value } }),

    setGlidePath: value =>
      dispatch({ type: "ACTIVE_GLIDE_PATH", payload: { value } }),

    setFundList: value =>
      dispatch({ type: "SET_ACCUMULATION_FUNDLIST", payload: { value } })
  })
)(Accumulation);



// WEBPACK FOOTER //
// ./src/components/pages/Retire/accumulation.jsx